<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[matDialogData]="data"
	[rect]="rect"
	[headerIcon]="{fontSet: 'fad', fontIcon: 'fa-user'}"
	[headerText]="T.CHANGE_OWNERSHIP | translate"
	class="normalDuotoneHeaderIcon trainerHeader"
>
	<div dialogContent>
		<div class="bottom">
			<div class="text">
				<div class="participantListContent">
					<div class="matTabContent">
						<form class="searchUserForm">
							<sim-user-chip-input
								placeholder="Assignee"
								[label]="T.CHANGE_OWNERSHIP | translate"
								[userFc]="addParticipantForm"
								[hasNewUserOption]="false"
								(optionSelected)="addUser()"
							/>
						</form>

						<div class="currentOwnerStyle">
							<div>{{ T.CURRENT_OWNERSHIP | translate }}</div>
						</div>

						@if (currentOwnership) {
							<div class="ParticipantsItem">
								<sim-user-list-item [user]="currentOwnership" [deletable]="false" />
							</div>
						}
					</div>
				</div>
			</div>
		</div>
	</div>

	<ng-container actions>
		<button mat-raised-button color="warn" (click)="close()" style="margin-right: 20px">
			{{ T.CREATE_BY_NAME_DIALOG_CLOSE_BUTTON | translate }}
		</button>

		<button mat-raised-button color="accent" [disabled]="!lastChangedUser" (click)="changeOwnership()">
			{{ T.CHANGE_THE_OWNER_BUTTON | translate }}
		</button>
	</ng-container>
</sim-basic-material-dialog>
